import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "./index";
import { OrderType } from "../enums";
import { OrderOptionModel, OrderTypeModel } from "../models";

const defaultOrderOption: OrderOptionModel = {
  order_date: null,
  order_time: null,
  order_instructions: "",
  type_id: OrderType.PICKUP,
  tip_status: "1",
  delivery_charge: 0,
  mov: "0",
  tip: "0",
  third_party_delivery_order: "0",
  utm_source: "",
};

// Read initial value from localStorage, fallback to default
const initialOrderOption: OrderOptionModel = (() => {
  // try {
  //   const raw = localStorage.getItem('order_option');
  //   if (raw) {
  //     return JSON.parse(raw) as OrderOptionModel;
  //   }
  // } catch {
  //   // ignore
  // }
  return defaultOrderOption;
})();

interface OrderOptionState {
  value: OrderOptionModel;
}

const initialState: OrderOptionState = {
  value: initialOrderOption,
};

const orderOptionSlice = createSlice({
  name: "orderOption",
  initialState,
  reducers: {
    setOrderOption(state, action: PayloadAction<OrderOptionModel>) {
      state.value = action.payload;
      // try {
      //   localStorage.setItem('order_option', JSON.stringify(action.payload));
      // } catch {
      //   // ignore
      // }
    },
    resetOrderOption(state) {
      state.value = defaultOrderOption;
      try {
        localStorage.removeItem("olo_utm");
      } catch {
        // ignore
      }
    },
    setOrderOptionUtmSource(state, action: PayloadAction<string>) {
      state.value = {
        ...state.value,
        utm_source: action.payload,
      };
      // try {
      //   localStorage.setItem('order_option', JSON.stringify(state.value));
      // } catch {
      //   // ignore
      // }
    },
  },
});

export const { setOrderOption, resetOrderOption, setOrderOptionUtmSource } =
  orderOptionSlice.actions;

export default orderOptionSlice.reducer;

// selector
export const selectOrderOption = (state: RootState) => state.orderOption.value;
export const selectDefaultOrderOption = () => defaultOrderOption;

export const resetOrderTypeToDefault = createAsyncThunk<
  void,
  void,
  { state: RootState }
>("orderOption/resetOrderTypeToDefault", (_, { dispatch, getState }) => {
  const state = getState();
  const orderTypes: OrderTypeModel[] = Array.isArray(
    state.store.selectedStore?.order_type,
  )
    ? state.store.selectedStore!.order_type
    : [];

  const available = new Set(orderTypes.map((t) => t.id));
  const typeId = available.has(OrderType.PICKUP)
    ? OrderType.PICKUP
    : available.has(OrderType.DELIVERY)
      ? OrderType.DELIVERY
      : available.has(OrderType.DINEIN)
        ? OrderType.DINEIN
        : OrderType.PICKUP;

  dispatch(setOrderOption({ ...state.orderOption.value, type_id: typeId }));
});
